module.exports = __webpack_public_path__ + "img/Raider-Locker-Room-BG.890178af.jpg";